import {dropdownSettingsResources, DropdownSettingsResourceType} from "./dropdown-settings-resource-type";
import {ResourceParams} from "../resources";

export type AdminResourceType =
  DropdownSettingsResourceType |
  'users' |
  'telegram-accounts' |
  'application-events';

export const adminResources: {
  [key in AdminResourceType]: ResourceParams
} = {
  ...dropdownSettingsResources,
  'users': {
    key: 'users',
    name: 'Пользователи',
    path: 'users',
  },
  'telegram-accounts': {
    key: 'telegram-accounts',
    name: 'Аккаунты Telegram',
    path: 'telegram-accounts'
  },
  'application-events': {
    key: 'application-events',
    name: 'События приложения',
    path: 'application-events',
  }
};
